import React, { useEffect } from 'react';

const ElfsightWidget = () => {
useEffect(() => {
  if (process.env.NODE_ENV === "production") {
    if (!document.getElementById("elfsight-platform-script")) {
      const script = document.createElement("script");
      script.id = "elfsight-platform-script";
      script.src = "https://static.elfsight.com/platform/platform.js";
      script.async = true;
      document.body.appendChild(script);
    }
  }
}, []);

  return (
    <div
      className="elfsight-app-59b769de-412d-40c4-b037-3159af758088 elfsight-widget"
      data-elfsight-app-lazy
    ></div>
  );
};

export default ElfsightWidget;
